import { DynamicFieldInstruction } from '@common/instructions/frontend-shared';
export class CompanyPaymentReminderInstruction extends DynamicFieldInstruction {
  getDefaults() {
    return {};
  }
  constructor(config) {
    super();
    this.isInput = false;
    this.useFieldWrapper = false;
    this.attributeMap = {};
    this.inputMap = {
      formService: 'formService'
    };
    this.setConfig(config);
  }
  load() {
    return import(/* webpackChunkName: "item-task-scheduler" */
    /* webpackMode: "lazy" */
    './company-reminder.widget').then(m => m.CompanyPaymentReminderWidget);
  }
  addDynamicInputValues(map, sourceMapName, formGroup, formService) {
    if (!formService) throw new Error('CompanyPaymentReminderInstruction can only be used with a FormService-based form!');
    map['formService'] = formService;
    return map;
  }
}